// extracted by mini-css-extract-plugin
export default {"logoUploader":"imagekitdirectupload_logoUploader__siAhc","image":"imagekitdirectupload_image__JAIZj"};